import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import Switch from 'react-switch';

import BrandingContext from '../../Context/BrandingContext';
import IconsContext from '../../Context/IconsContext';
export const EditAssetCCDisplay = ({ commandAndControl, handleCCToggle }) => {
  const { primary_alert } = useContext(BrandingContext);
  const { commandControlIcon } = useContext(IconsContext);
  return (
    <>
      <div className="p-0 mt-0">
        <label>
          Command and Control{' '}
          <span>
            <img
              className="command-and-control-icon"
              src={commandControlIcon}
              alt="command-and-control-icon"
            />
          </span>
        </label>

        <div className="w-100 d-flex mt-0">
          <div className="flex-grow-1 d-flex align-items-center">
            <Switch
              onChange={handleCCToggle}
              checked={commandAndControl}
              checkedIcon={false}
              uncheckedIcon={false}
              height={10}
              width={20}
              onColor={primary_alert}
            />
            {commandAndControl === true ? (
              <span className="font-weight-light text-muted ml-2 small">
                Sending remote commands enabled
              </span>
            ) : (
              <span className="font-weight-light text-muted ml-2 small">
                Sending remote commands disabled
              </span>
            )}
          </div>
        </div>
      </div>
      <style jsx>{`
        .command-and-control-icon {
          max-height: 20px;
          margin-right: 5px;
          margin-bottom: 5px;
        }
      `}</style>
    </>
  );
};

EditAssetCCDisplay.propTypes = {
  commandAndControl: PropTypes.bool,
  handleCCToggle: PropTypes.func,
};

EditAssetCCDisplay.defaultProps = {
  commandAndControl: false,
  handleCCToggle: () => {},
};
